// import { useState, useEffect } from "react";
// import Container from 'react-bootstrap/Container';
// import Table from 'react-bootstrap/Table';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import { MyFetch } from "../../App";
// import { useNavigate } from 'react-router-dom';
// import Button from "react-bootstrap/esm/Button";
// import ProgressBar from 'react-bootstrap/ProgressBar';



// const AssignedTasks = (props) => {
//     const [list_Data, set_List_Data] = useState([])
//     const [employee, setEmployee] = useState({});
//     const [client, setClient] = useState({});

//     const navigate = useNavigate()

//     console.log("Logged in user:", props.user);


//     const getProgressBarVariant = (progress) => {
//         if (progress < 20) return "danger";
//         if (progress < 100) return "warning";
//         return "success";
//     };

//     useEffect(() => {
//         MyFetch("https://easytasks.in/tasks/list", {}, "GET")
//             .then((res) => res.json())
//             .then((data) => {
//                 const filteredTasks = data.filter(task => task.emp_id === props.user.id);
//                 set_List_Data(filteredTasks);
//             }) // Close the .then chain
//             .catch((error) => console.error('Error fetching tasks:', error)); // Optionally handle any errors
//     }, [props.user.id]);

//     //  useEffect(() => {
//     //     MyFetch("https://easytasks.in/tasks/list", {}, "POST")
//     //         .then((res) => res.json())
//     //         .then((data) => set_List_Data(data));
//     // }, [])


//     useEffect(() => {
//         MyFetch("https://easytasks.in/employee/list", {}, "GET")
//             .then((res) => res.json())
//             .then((data) => {
//                 const employeeMap = {};
//                 data.forEach(employee => employeeMap[employee.id] = employee.name);
//                 setEmployee(employeeMap);
//             })
//             .catch((error) => {
//                 console.error('Error fetching employee data:', error);
//             });
//     }, []);

//     useEffect(() => {
//         MyFetch("https://easytasks.in/client/list", {}, "GET")
//             .then((res) => res.json())
//             .then((data) => {
//                 const clientMap = {};
//                 data.forEach(client => clientMap[client.id] = client.name);
//                 setClient(clientMap);
//             })
//             .catch((error) => {
//                 console.error('Error fetching client data:', error);
//             });
//     }, []);

//     const renderTasks = (tasks, index) => {
//         return (
//             <tr key={index}>
//                 <td>{index}</td>
//                 <td>{tasks.id}</td>
//                 <td>{tasks.task_name}</td>
//                 <td>{tasks.data_assigned}</td>
//                 <td>{tasks.task_desc}</td>
//                 <td>{tasks.date_due}</td>
//                 {/* <td>{tasks.emp_id}</td>
//                 <td>{tasks.client_id}</td> */}
//                 {/* <td>{employee[tasks.emp_id]}</td> */}
//                 <td>{client[tasks.client_id]}</td>
//                 <td> <ProgressBar 
//                 now={tasks.progress}     
//                 label={<span style={{ color: 'White', fontWeight: 'bold' }}>{`${tasks.progress}%`}</span>}
//                 variant={getProgressBarVariant(tasks.progress)}
//                 /> </td>
//                 <td><Button variant="outline-secondary" onClick={() => navigate('/tasks/edit', { state: { taskid: tasks.id } })}>Update</Button></td>
//             </tr>
//         )
//     };

//     return (
//         <Container className='mt-5'>
//             <Row className="justify-content-md-left">
//                 <Col xs lg="5" >
//                     <h2 className='my-5'><b>VIEW ALL TASKS</b></h2>
//                 </Col>
//             </Row>
//             <Table striped bordered hover size='sm'>
//                 <thead>
//                     <tr>
//                         <th>#</th>
//                         <th>task id</th>
//                         <th>Task Name</th>
//                         <th>Date assigned</th>
//                         <th>Task description</th>
//                         <th>Due date</th>
//                         {/* <th>Employee assigned</th> */}
//                         <th>Client assigned</th>
//                         <th>progress</th>
//                         <th>Action</th>

//                     </tr>
//                 </thead>
//                 <tbody>
//                     {list_Data && list_Data.length > 0 ? list_Data.map(renderTasks) : <></>}
//                     {/* {console.log(list_Data)} */}
//                 </tbody>
//             </Table>
//         </Container>
//     )
// }

// export default AssignedTasks;


import { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { MyFetch } from "../../App";
import { useNavigate } from 'react-router-dom';
import Button from "react-bootstrap/esm/Button";
import ProgressBar from 'react-bootstrap/ProgressBar';

const AssignedTasks = (props) => {
    const [list_Data, set_List_Data] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [employee, setEmployee] = useState({});
    const [client, setClient] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [filter, setFilter] = useState({ client: '', date_due: '', progress: false });

    const navigate = useNavigate();

    console.log("Logged in user:", props.user);

    const getProgressBarVariant = (progress) => {
        if (progress < 20) return "danger";
        if (progress < 100) return "warning";
        return "success";
    };

    useEffect(() => {
        MyFetch("https://easytasks.in/tasks/list", {}, "GET")
            .then((res) => res.json())
            .then((data) => {
                const filteredTasks = data.filter(task => task.emp_id === props.user.id);
                set_List_Data(filteredTasks);
                setFilteredData(filteredTasks); // Initialize filtered data
            })
            .catch((error) => console.error('Error fetching tasks:', error));
    }, [props.user.id]);

    useEffect(() => {
        MyFetch("https://easytasks.in/client/list", {}, "GET")
            .then((res) => res.json())
            .then((data) => {
                const clientMap = {};
                data.forEach(client => clientMap[client.id] = client.name);
                setClient(clientMap);
            })
            .catch((error) => {
                console.error('Error fetching client data:', error);
            });
    }, []);

    const sortData = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        const sortedList = [...filteredData].sort((a, b) => {
            if (a[key] < b[key]) {
                return direction === 'asc' ? -1 : 1;
            }
            if (a[key] > b[key]) {
                return direction === 'asc' ? 1 : -1;
            }
            return 0;
        });
        setFilteredData(sortedList);
        setSortConfig({ key, direction });
    };

    const filterData = () => {
        let filtered = [...list_Data];

        if (filter.client) {
            filtered = filtered.filter(task =>
                client[task.client_id]?.toLowerCase().includes(filter.client.toLowerCase())
            );
        }

        if (filter.date_due) {
            filtered = filtered.filter(task =>
                task.date_due && task.date_due.startsWith(filter.date_due)
            );
        }

        // Filter out tasks with 100% progress if the "progress" filter is checked
        if (filter.progress) {
            filtered = filtered.filter(task => task.progress < 100);
        }

        setFilteredData(filtered);
    };

    const handleFilterChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFilter({
            ...filter,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    useEffect(() => {
        filterData();
    }, [filter]);

    const renderTasks = (tasks, index) => {
        return (
            <tr key={index}>
                {/* <td>{index}</td> */}
                <td>{tasks.id}</td>
                <td>{tasks.task_name}</td>
                {/* <td>{tasks.data_assigned}</td> */}
                <td>{tasks.task_desc}</td>
                <td>{tasks.date_due}</td>
                <td>{client[tasks.client_id]}</td>
                <td>
                    <ProgressBar
                        now={tasks.progress}
                        label={<span style={{ color: 'White', fontWeight: 'bold' }}>{`${tasks.progress}%`}</span>}
                        variant={getProgressBarVariant(tasks.progress)}
                    />
                </td>
                <td>
                    <Button variant="outline-secondary" onClick={() => navigate('/tasks/edit', { state: { taskid: tasks.id } })}>
                        Update
                    </Button>
                </td>
            </tr>
        );
    };

    return (
        <Container className='mt-5'>
            <Row className="justify-content-md-left">
                <Col xs lg="5">
                    <h2 className='my-5'><b>VIEW ASSIGNED TASKS</b></h2>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.Control
                        type="text"
                        placeholder="Filter by client"
                        name="client"
                        value={filter.client}
                        onChange={handleFilterChange}
                    />
                </Col>
                <Col>
                    <Form.Control
                        type="date"
                        placeholder="Filter by due date"
                        name="date_due"
                        value={filter.date_due}
                        onChange={handleFilterChange}
                    />
                </Col>
                <Col>
                    <Form.Check
                        type="checkbox"
                        label="Display Only Incomplete Tasks"
                        name="progress"
                        checked={filter.progress}
                        onChange={handleFilterChange}
                    />
                </Col>
            </Row>
            <Table striped bordered hover size='sm'>
                <thead>
                    <tr>
                        {/* <th>#</th> */}
                        <th onClick={() => sortData('id')}>Task ID</th>
                        <th onClick={() => sortData('task_name')}>Task Name</th>
                        {/* <th>Date Assigned</th> */}
                        <th>Task Description</th>
                        <th onClick={() => sortData('date_due')}>Due Date</th>
                        <th onClick={() => sortData('client_id')}>Client Assigned</th>
                        <th onClick={() => sortData('progress')}>Progress</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredData && filteredData.length > 0 ? filteredData.map(renderTasks) : <></>}
                </tbody>
            </Table>
        </Container>
    );
};

export default AssignedTasks;
